export const SUCCESS = 'SUCCESS'
export const PARTIAL_SUCCESS = 'PARTIAL_SUCCESS'
export const ERROR = 'ERROR'
export const LOADING = 'LOADING'
export const STATIC = 'STATIC'
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE'
export const AUTO = 'AUTO'
export const EXACT = 'EXACT'
